type KeywordValue = string[] | string | null | undefined

function parseKeywordList(value: KeywordValue): string[] {
  if (value == null) {
    return []
  }

  if (Array.isArray(value)) {
    return value.filter(item => typeof item === 'string')
  }

  try {
    const parsed = JSON.parse(value)
    if (!Array.isArray(parsed)) {
      return []
    }
    return parsed.filter(item => typeof item === 'string')
  } catch {
    return []
  }
}

type BuildInstantwinPrizeKeywordParams = {
  prizeEntryKeyword?: KeywordValue
}

export function buildInstantwinPrizeKeywordText(params: BuildInstantwinPrizeKeywordParams): string {
  const prizeKeywords = parseKeywordList(params.prizeEntryKeyword)

  return prizeKeywords.join(' ')
}
